import React from 'react';
import './News.css';

const News = () => {
  const newsItems = [
    {
      id: 1,
      date: '03',
      month: 'Th2',
      title: 'GNINE SOLAR – NHÀ CUNG CẤP GIẢI PHÁP NĂNG LƯỢNG MẶT TRỜI DẪN ĐẦU VIỆT NAM 2026',
      excerpt: 'Ngày 25/01/2026, Gnine Solar được vinh danh với danh hiệu: "Nhà cung cấp giải pháp năng lượng mặt trời dẫn đầu Việt Nam"...',
      image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Tin tức',
      link: '#'
    },
    {
      id: 2,
      date: '02',
      month: 'Th1',
      title: 'Sở hữu điện mặt trời trả góp cho gia đình dễ dàng như mua một chiếc xe máy',
      excerpt: 'Điện mặt trời trả góp: Giải pháp giúp hộ gia đình Việt dễ dàng sở hữu hệ thống điện năng lượng mặt trời...',
      image: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Tin tức',
      link: '#'
    },
    {
      id: 3,
      date: '15',
      month: 'Th12',
      title: 'LẮP ĐẶT ĐIỆN MẶT TRỜI GIẢI PHÁP TỐI ƯU SẢN XUẤT CHO DOANH NGHIỆP',
      excerpt: 'Lắp điện mặt trời doanh nghiệp cùng Gnine. Vừa qua, ngày 10/12, Gnine đã chính thức hoàn thành lắp đặt...',
      image: 'https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Dự án',
      link: '#'
    },
    {
      id: 4,
      date: '28',
      month: 'Th11',
      title: 'HUAWEI x GNINE SOLAR: KÝ KẾT CHIẾN LƯỢC HỢP TÁC',
      excerpt: 'Ngày 27/9/2025, tại Hội thảo "Vietnam Installer Summit 2025", Gnine Solar và tập đoàn công nghệ...',
      image: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Sự kiện',
      link: '#'
    },
    {
      id: 5,
      date: '28',
      month: 'Th11',
      title: 'LẮP ĐẶT ĐIỆN MẶT TRỜI GIA ĐÌNH DỄ DÀNG NHỜ GIẢI PHÁP TRẢ GÓP',
      excerpt: 'Lắp đặt điện mặt trời gia đình – Giải pháp năng lượng bền vững, tài chính linh hoạt...',
      image: 'https://images.unsplash.com/photo-1558449028-b53a39d100fc?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Tin tức',
      link: '#'
    },
    {
      id: 6,
      date: '27',
      month: 'Th11',
      title: 'QUY TRÌNH LẮP ĐẶT ĐIỆN MẶT TRỜI – CHẤT LƯỢNG VÀ AN TOÀN',
      excerpt: 'Quy trình lắp đặt điện mặt trời – Tuân thủ tiêu chuẩn an toàn và chất lượng cao nhất...',
      image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Kinh nghiệm',
      link: '#'
    }
  ];

  const featuredNews = newsItems[0];
  const otherNews = newsItems.slice(1);

  return (
    <section id="news" className="news-section">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-tag">TIN TỨC</span>
          <h2 className="section-title">TIN TỨC - SỰ KIỆN</h2>
          <p className="section-subtitle">
            Cập nhật những tin tức mới nhất về Gnine Solar và ngành năng lượng mặt trời
          </p>
        </div>

        <div className="news-layout">
          {/* Featured News */}
          <div className="featured-news" data-aos="fade-right">
            <div className="news-card featured">
              <div className="news-image">
                <img src={featuredNews.image} alt={featuredNews.title} />
                <div className="news-date">
                  <span className="date">{featuredNews.date}</span>
                  <span className="month">{featuredNews.month}</span>
                </div>
                <div className="news-category">{featuredNews.category}</div>
              </div>
              <div className="news-content">
                <h3 className="news-title">{featuredNews.title}</h3>
                <p className="news-excerpt">{featuredNews.excerpt}</p>
                <a href={featuredNews.link} className="news-read-more">
                  Xem thêm
                  <i className="fas fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
          </div>

          {/* News Grid */}
          <div className="news-grid" data-aos="fade-left">
            {otherNews.map((news, index) => (
              <div 
                key={news.id} 
                className="news-card"
                data-aos="fade-up"
                data-aos-delay={index * 50}
              >
                <div className="news-image">
                  <img src={news.image} alt={news.title} />
                  <div className="news-date">
                    <span className="date">{news.date}</span>
                    <span className="month">{news.month}</span>
                  </div>
                </div>
                <div className="news-content">
                  <span className="news-category-tag">{news.category}</span>
                  <h4 className="news-title">{news.title}</h4>
                  <a href={news.link} className="news-link">
                    Xem thêm <i className="fas fa-chevron-right"></i>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="news-cta" data-aos="fade-up">
          <a href="#" className="btn btn-primary">
            Xem tất cả tin tức
            <i className="fas fa-arrow-right ms-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default News;